import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Modal,
  CircularProgress,
  debounce,
  IconButton,
  keyframes,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import "./Items.css";

import { backend, API_URL, STRIPE_KEY } from "../../../config";

import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { loadStripe } from "@stripe/stripe-js";

import { Elements } from "@stripe/react-stripe-js";

import {
  ShoppingCart as ShoppingCartIcon,
  DeleteSweep as DeleteSweepIcon,
  Dashboard as DashboardIcon,
  TableRows as TableRowsIcon,
} from "@mui/icons-material";

import CardCart from "../../Cards/Cart/Cart";
import FormCart from "../../Forms/Cart/Cart";
import DetailsOrder from "../../../components/Details/Order";
import InfiniteTable from "../../InfiniteTable/InfiniteTable";

import { useDispatch, useSelector } from "react-redux";
import { initialize_cart_action } from "./../../../redux/actions/cart";
import Payment from "../../Forms/Payment/Payment";

const stripePromise = loadStripe(STRIPE_KEY);

const columns = [
  { id: "upc", label: "UPC" },
  {
    id: "url",
    label: "Image",
  },
  {
    id: "name",
    label: "Name",
  },
  {
    id: "display_unit_price",
    label: "Unit",
  },
  {
    id: "display_case_price",
    label: "Case",
  },
];

const pulseInset = keyframes`
  0% {
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
  }
  50% {
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.8), inset 0 0 15px rgba(255, 255, 255, 0.4);
  }
  100% {
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
  }
`;

const useStyles = makeStyles((theme) => ({
  tableBody: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const Items = (props) => {
  const { location, steps } = props;

  const classes = useStyles();
  const theme = useTheme();

  const appearance = {
    theme: "stripe",
  };

  const loader = "auto";

  const dispatch = useDispatch();
  const cartStore = useSelector((state) => state.cart);
  const customerStore = useSelector((state) => state.customer);

  const [activeStep, setActiveStep] = useState(0);
  const [stagedStore, setStagedStore] = useState([]);
  const [stagedStoreTotal, setStagedStoreTotal] = useState(0);
  const [stagedStoreLoaded, setStagedStoreLoaded] = useState(false);
  const [stagedStoreMapped, setStagedStoreMapped] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [confirmOrderModal, setConfirmOrderModal] = useState(false);
  const [saveStagedOrderModal, setSaveStagedOrderModal] = useState(false);
  const [clearOrderModal, setClearOrderModal] = useState(false);
  const [refreshStagedOrder, setRefreshStagedOrder] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [view, setView] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [ordersWithinDeadline, setOrdersWithinDeadline] = useState([]);
  const [ordersWithinDeadlineLoaded, setOrdersWithinDeadlineLoaded] =
    useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStagedOrder = () => {
    setIsSaving(true);

    let errorFlag = false;

    const customerCLocation = customerStore.company_location
      ? customerStore.company_location[0]
      : null;

    const itemsToSave = cartStore[customerStore.id].products.map((item) => ({
      upc: item.upc,
      company_location: customerCLocation,
      unit_quantity: item.unit_in_cart,
      case_quantity: item.case_in_cart,
    }));

    Promise.all(
      itemsToSave.map(async (item) => {
        let payload = { ...item };
        await backend
          .post(`${API_URL}sharedcartitems/?force_add=True`, payload)
          .then(({ data }) => {
            payload = { ...item, ...data };
          })
          .catch((error) => {
            console.log(error);
            const errorData = error.response.data;
            errorFlag = true;

            setErrorInfo({
              error: true,
              message:
                typeof errorData === "object"
                  ? errorData.hasOwnProperty("message")
                    ? errorData.message
                    : errorData.detail
                  : error.message,
            });
          });

        return payload;
      }),
    )
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;
        errorFlag = true;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
      })
      .finally(() => {
        setIsSaving(false);

        if (!errorFlag) {
          dispatch(initialize_cart_action([], customerStore));
          setRefreshStagedOrder(true);
          toggleSaveStagedOrderModal();
        }
      });
  };

  const handleClearOrder = () => {
    if (location.search.includes("stagedOrder=1")) {
      let errorFlag = false;

      Promise.resolve(clearStagedOrder())
        .then(() => {
          handleBackToAdd();
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;
          errorFlag = true;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        })
        .finally(() => {
          if (!errorFlag) {
            toggleClearOrderModal();
          }
        });
    } else {
      dispatch(initialize_cart_action([], customerStore));
      toggleClearOrderModal();
      handleBackToAdd();
    }
  };

  const handleClickCardView = () => {
    setView(1);
  };

  const handleClickTableView = () => {
    setView(2);
  };

  const handleBackToAdd = () => props.history.push("/orders/add");

  const handleCancel = () => props.history.push("/orders");

  const handleConfirm = async (piData = null) => {
    setIsSaving(true);

    let errorFlag = false;
    const cDate = new Date();

    const orderTotal = location.search.includes("stagedOrder=1")
      ? stagedStoreTotal
      : cartStore[customerStore.id].total;

    const orderItems = location.search.includes("stagedOrder=1")
      ? stagedStore
      : cartStore[customerStore.id].products;

    const orderItemsMap = orderItems.map((item) => ({
      product: item.upc,
      original_product: item.upc,
      unit_quantity: item.unit_in_cart,
      case_quantity: item.case_in_cart,
    }));

    const orderObj = {
      customer: customerStore.id,
      submitted_date: cDate.toISOString(),
      created_date: cDate.toISOString(),
      total: orderTotal,
      order_items: orderItemsMap,
    };

    const codPaymentEnabled = Boolean(
      customerStore?.company_location_data?.[0]?.cod_payments_enabled,
    );

    if (codPaymentEnabled && !Boolean(paymentIntent)) {
      setIsSaving(false);
      errorFlag = true;
      setErrorInfo({
        error: true,
        message:
          "Cash on Delivery payment enabled but no payment intent, cannot place order. Please try again.",
      });
    }

    await backend
      .post(`${API_URL}orders/`, orderObj)
      .then(async ({ data }) => {
        if (!codPaymentEnabled) {
          setIsSaving(false);
        }

        if (codPaymentEnabled) {
          const payloadObj = {
            payment_intent_id: piData?.id || paymentIntent?.payment_intent?.id,
          };

          await backend
            .post(`${API_URL}orders/${data.id}/invoice/codpayment`, payloadObj)
            .then(() => {
              setIsSaving(false);
            })
            .catch((error) => {
              console.log(error);
              const errorData = error.response.data;
              errorFlag = true;

              setErrorInfo({
                error: true,
                message:
                  typeof errorData === "object"
                    ? errorData.hasOwnProperty("message")
                      ? errorData.message
                      : errorData.detail
                    : error.message,
              });

              setIsSaving(false);
            });
        }
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;
        errorFlag = true;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
        setIsSaving(false);
      })
      .finally(() => {
        if (!errorFlag) {
          toggleConfirmOrderModal();

          if (location.search.includes("stagedOrder=1")) {
            clearStagedOrder();
          } else {
            dispatch(initialize_cart_action([], customerStore));
          }
          props.history.push("/orders");
        }
      });
  };

  const handleConfirmCOD = (piData) => {
    setPaymentIntent((prevState) => ({ ...prevState, payment_intent: piData }));
    handleConfirm(piData);
  };

  const clearStagedOrder = async () => {
    const customerCLocation = customerStore.company_location
      ? customerStore.company_location[0]
      : null;

    const payloadObj = { company_location_id: customerCLocation };

    return await backend.post(`${API_URL}sharedcartclear/`, payloadObj);
  };

  const stagedChange = (data, action, amount, type = true) => {
    // action 1 = add, 2 = substract, 3 = amount, 4 = delete
    // type true = unit, false = case
    const itemIndex = stagedStore.findIndex((item) => item.upc === data.upc);

    if (itemIndex === -1 && action !== 1) return; // shouldnt be possible as items are already created

    const itemProp = type ? "unit_in_cart" : "case_in_cart";

    let stagedItems = [].concat(stagedStore);

    switch (action) {
      case 1:
        if (itemIndex === -1) {
          let itemObj = {
            ...data,
            id: null,
            deleted: false,
            modified: false,
            new: true,
            [itemProp]: +amount,
          };

          stagedItems.push(itemObj);
        } else {
          stagedItems[itemIndex][itemProp] =
            stagedItems[itemIndex][itemProp] + +amount;
          stagedItems[itemIndex]["modified"] = true;
        }
        break;
      case 2:
        stagedItems[itemIndex][itemProp] =
          stagedItems[itemIndex][itemProp] - +amount;
        stagedItems[itemIndex]["modified"] = true;

        if (
          stagedItems[itemIndex].unit_in_cart === 0 &&
          stagedItems[itemIndex].case_in_cart === 0
        ) {
          // stagedItems.splice(itemIndex, 1);
          stagedItems[itemIndex]["deleted"] = true;
        }
        break;
      case 3:
        stagedItems[itemIndex][itemProp] = +amount;
        stagedItems[itemIndex]["modified"] = true;

        if (
          stagedItems[itemIndex].unit_in_cart === 0 &&
          stagedItems[itemIndex].case_in_cart === 0
        ) {
          // stagedItems.splice(itemIndex, 1);
          stagedItems[itemIndex]["deleted"] = true;
        }
        break;
      case 4:
        // stagedItems.splice(itemIndex, 1);
        stagedItems[itemIndex]["deleted"] = true;
        break;
      default:
        return stagedItems;
    }

    setStagedStore(stagedItems);

    const customerCLocation = customerStore.company_location
      ? customerStore.company_location[0]
      : null;

    debounceStagedChangeRequest(stagedItems, customerCLocation);
  };

  const stagedChangeRequest = useCallback((stagedItems, customerCLocation) => {
    Promise.all(
      stagedItems.map(async (item) => {
        if (item.deleted) {
          await backend
            .delete(`${API_URL}sharedcartitems/${item.id}`)
            .catch((error) => {
              console.log(error);
            });
        } else if (item.modified && !item.new) {
          const payload = {
            upc: item.upc,
            company_location: customerCLocation,
            unit_quantity: item.unit_in_cart,
            case_quantity: item.case_in_cart,
          };

          await backend
            .patch(`${API_URL}sharedcartitems/${item.id}`, payload)
            .then(({ data }) => {
              item = { ...item, ...data, modified: false };
            });
        } else if (item.id !== null && item.new) {
          const payload = {
            upc: item.upc,
            company_location: customerCLocation,
            unit_quantity: item.unit_in_cart,
            case_quantity: item.case_in_cart,
          };

          await backend
            .post(`${API_URL}sharedcartitems/?force_add=True`, payload)
            .then(({ data }) => {
              item = { ...item, ...data, new: false };
            });
        }

        return item;
      }),
    ).then((result) => {
      const stagedItemsNew = result.filter((item) => !item.deleted);
      setStagedStore(stagedItemsNew);
    });
  }, []);

  const debounceStagedChangeRequest = useMemo(() => {
    return debounce(stagedChangeRequest, 1000);
  }, [stagedChangeRequest]);

  const handleClickPlaceOrder = async () => {
    if (customerStore?.company_location_data?.[0]?.cod_payments_enabled) {
      toggleConfirmOrderModal();
      setIsLoading(true);

      const cartProducts = location.search.includes("stagedOrder=1")
        ? stagedStore.filter((item) => !item.deleted)
        : cartStore?.[customerStore.id]?.products || [];

      const cartItemsMap = cartProducts.map((item) => ({
        upc: item.upc,
        unit_quantity: item.unit_in_cart,
        case_quantity: item.case_in_cart,
      }));

      const payloadObj = {
        cart_items: cartItemsMap,
      };

      await backend
        .post(`${API_URL}codpayments/initiate`, payloadObj)
        .then(({ data: paymentData }) => {
          setPaymentIntent(paymentData);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });

          setIsLoading(false);
        });
    } else {
      toggleConfirmOrderModal();
    }
  };

  const toggleConfirmOrderModal = () => {
    setErrorInfo({ error: false, message: "" });
    setConfirmOrderModal(!confirmOrderModal);
  };

  const confirmOrderModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an issue processing the order
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
              textAlign: "left",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={toggleConfirmOrderModal}>
              Continue
            </Button>
          </div>
        </>
      ) : isSaving || isLoading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <br />
          <br />
          {isSaving ? "Saving order..." : "Loading..."}
        </div>
      ) : customerStore?.company_location_data?.[0]?.cod_payments_enabled &&
        !isLoading ? (
        <div
          style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}
        >
          <b>Cash on Delivery summary</b>
          <br />
          <br />
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow hover tabIndex={-1} className={classes.tableBody}>
                  <TableCell
                    style={{
                      textAlign: "right",
                      textTransform: "capitalize",
                    }}
                  >
                    <b>Estimated Total:</b>
                  </TableCell>
                  <TableCell>
                    {paymentIntent?.estimated_total_at_checkout?.toFixed(2)}
                  </TableCell>
                </TableRow>
                {Boolean(paymentIntent?.delivery_fee) && (
                  <TableRow hover tabIndex={-1} className={classes.tableBody}>
                    <TableCell
                      style={{
                        textAlign: "right",
                        textTransform: "capitalize",
                      }}
                    >
                      <b>Delivery Fee:</b>
                    </TableCell>
                    <TableCell>
                      {paymentIntent?.delivery_fee?.toFixed(2)}
                    </TableCell>
                  </TableRow>
                )}
                {/* Boolean(paymentIntent?.delivery_fee) && (
                  <TableRow hover tabIndex={-1} className={classes.tableBody}>
                    <TableCell
                      style={{
                        textAlign: "right",
                        textTransform: "capitalize",
                      }}
                    >
                      <b>Grand Total:</b>
                    </TableCell>
                    <TableCell>
                      {(
                        paymentIntent?.estimated_total_at_checkout +
                        (paymentIntent?.delivery_fee || 0)
                      )?.toFixed(2)}
                    </TableCell>
                  </TableRow>
                ) */}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ lineHeight: 0 }}
          >
            * The final price may vary slightly based on the actual weight,
            availability of the items or market fluctuations.
          </Typography>
          <br />
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ lineHeight: 0 }}
          >
            {(() => {
              const totalAmount = location.search.includes("stagedOrder=1")
                ? stagedStoreTotal
                : (customerStore && cartStore[customerStore.id].total) || 0;

              const percentateHold =
                paymentIntent?.cod_percentage_overcapture || 0.1;
              const totalHoldAmount =
                paymentIntent?.order_overcapture_total ||
                totalAmount * (1 + percentateHold);

              return `* A temporary hold of ${percentateHold * 100}% over the total ($${totalHoldAmount.toFixed(2)}) + delivery fee if applies, will be placed on your card to cover variance in final price.`;
            })()}
          </Typography>
          <br />
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ lineHeight: 0 }}
          >
            * Your final invoice will be adjusted down once finalized
          </Typography>
          <br />
          <br />
          {paymentIntent !== null && (
            <Elements
              options={{
                clientSecret: paymentIntent.stripe_client_secret,
                customerSessionClientSecret:
                  paymentIntent.customer_session_client_secret,
                appearance,
                loader,
              }}
              stripe={stripePromise}
            >
              <Payment
                {...props}
                dismissPaymentModal={() => toggleConfirmOrderModal()}
                returnUrl={`${window.location.protocol}//${window.location.host}/cart`}
                codPayment={true}
                handleConfirmCOD={handleConfirmCOD}
              />
            </Elements>
          )}
        </div>
      ) : (
        <>
          Are you sure you want to submit the order?
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleConfirmOrderModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleConfirm()}
              className={classes.button}
              disabled={isSaving}
            >
              Confirm
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleSaveStagedOrderModal = () => {
    setErrorInfo({ error: false, message: "" });
    setSaveStagedOrderModal(!saveStagedOrderModal);
  };

  const saveStagedOrderModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an issue saving items to the staged order
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
              textAlign: "left",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={toggleSaveStagedOrderModal}>
              Continue
            </Button>
          </div>
        </>
      ) : isSaving ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <br />
          <br />
          Saving items to staged order
        </div>
      ) : (
        <>
          Are you sure you want to save these items to the staged order?
          <br />
          <br />
          <b>Note: </b>The current items will be removed from your cart and
          added to the staged order.
          <br />
          <br />
          Your staged order is available in all devices until the staged order
          is placed.
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleSaveStagedOrderModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleSaveStagedOrder()}
              className={classes.button}
              disabled={isSaving}
            >
              Confirm
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleClearOrderModal = () => {
    setErrorInfo({ error: false, message: "" });
    setClearOrderModal(!clearOrderModal);
  };

  const clearOrderModalContent = (
    <div className={classes.modal}>
      {errorInfo.error ? (
        <>
          There was an issue trying to clear the items
          <br />
          <br />
          <span
            style={{
              color: "red",
              wordBreak: "break-word",
              maxHeight: 160,
              overflow: "hidden",
              display: "inline-block",
              textAlign: "left",
            }}
          >
            <b>Error:</b>
            <br />
            {errorInfo.message}
          </span>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={toggleClearOrderModal}>
              Continue
            </Button>
          </div>
        </>
      ) : isSaving ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <br />
          <br />
          Clearing items
        </div>
      ) : (
        <>
          Are you sure you want to clear these items?
          <br />
          <br />
          <b>Note: </b>This action will remove all your items permanently.
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleClearOrderModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClearOrder()}
              className={classes.button}
              disabled={isSaving}
            >
              Confirm
            </Button>
          </div>
        </>
      )}
    </div>
  );

  useEffect(() => {
    const getStagedStore = async () => {
      const customerCLocation = customerStore.company_location
        ? customerStore.company_location[0]
        : null;

      await backend
        .get(
          `${API_URL}sharedcartitems?no_page=1&company_location_id=${customerCLocation}`,
        )
        .then(({ data }) => {
          setStagedStore(data);
          setStagedStoreLoaded(true);
          setRefreshStagedOrder(false);
          setStagedStoreMapped(false);
        });
    };

    if (location.search.includes("stagedOrder=1") || refreshStagedOrder) {
      getStagedStore();
    }
  }, [customerStore, location, refreshStagedOrder]);

  useEffect(() => {
    const getStagedStoreProducts = async () => {
      const productsUPCs = stagedStore.map((item) => item.upc);

      const productsUPCsStr = productsUPCs.join("&upc=");

      await backend
        .get(
          `${API_URL}products?upc=${productsUPCsStr}&include_inactive=true&include_nonprimary=true&no_page=1`,
        )
        .then(({ data }) => {
          const dataMap = data.map((item) => ({
            ...item,
            unit_in_cart: 0,
            case_in_cart: 0,
            added_in_cart: false,
            added_through_sub: false,
          }));

          stageStoreMapping(dataMap);
        });
    };

    const stageStoreMapping = (products) => {
      setStagedStore((prevState) =>
        prevState.map((item) => {
          const productObj = products.find(
            (productItem) => productItem.upc === item.upc,
          );

          if (!productObj) return item;

          return {
            ...productObj,
            ...item,
            unit_in_cart: item.unit_quantity,
            case_in_cart: item.case_quantity,
            deleted: false,
            modified: false,
            new: false,
          };
        }),
      );

      setStagedStoreMapped(true);
    };

    const stagedStoreTotalize = () => {
      let stagedTotal = stagedStore
        .filter((item) => !item.deleted)
        .reduce((total, item) => {
          const unitTotal = item.unit_in_cart
            ? item.display_unit_price * item.unit_in_cart
            : 0;
          const caseTotal = item.case_in_cart
            ? item.display_case_price * item.case_in_cart
            : 0;

          return total + unitTotal + caseTotal;
        }, 0);
      setStagedStoreTotal(stagedTotal);
    };

    if (stagedStore.length && !stagedStoreMapped) {
      getStagedStoreProducts();
    }
    if (stagedStore.length && stagedStoreMapped) {
      stagedStoreTotalize();
    }
  }, [stagedStore, stagedStoreMapped]);

  useEffect(() => {
    const getOrdersWithinDeadline = async () => {
      await backend
        .get(`${API_URL}orderswithindeadline/?no_page=1`)
        .then(({ data }) => {
          setOrdersWithinDeadline(data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (customerStore && !ordersWithinDeadlineLoaded) {
      getOrdersWithinDeadline();
      setOrdersWithinDeadlineLoaded(true);
    }
  }, [customerStore, ordersWithinDeadlineLoaded]);

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Modal open={confirmOrderModal}>{confirmOrderModalContent}</Modal>
      <Modal open={saveStagedOrderModal}>{saveStagedOrderModalContent}</Modal>
      <Modal open={clearOrderModal}>{clearOrderModalContent}</Modal>
      <Typography variant="h6" component="div">
        {location.search.includes("stagedOrder=1") ? "Staged Order" : "Cart"}
      </Typography>
      {activeStep === steps.length ? (
        <>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
          </Box>
        </>
      ) : (
        <>
          <Grid container spacing={2} sx={{ mt: 2, mb: 1 }}>
            {activeStep === 0 ? (
              <>
                <Grid item xs={12} md={7}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} textAlign="right">
                      <Button
                        variant="contained"
                        startIcon={<DeleteSweepIcon />}
                        disabled={
                          location.search.includes("stagedOrder=1")
                            ? !stagedStore.filter((item) => !item.deleted)
                                .length
                            : !cartStore[customerStore?.id]?.products.length
                        }
                        onClick={toggleClearOrderModal}
                      >
                        {location.search.includes("stagedOrder=1")
                          ? "Clear Staged Order"
                          : "Clear Cart"}
                      </Button>
                    </Grid>
                    <Grid item xs={12} textAlign="right">
                      <IconButton onClick={handleClickCardView}>
                        <DashboardIcon
                          className={view === 1 ? "activeView" : ""}
                        />
                      </IconButton>
                      <IconButton onClick={handleClickTableView}>
                        <TableRowsIcon
                          className={view === 2 ? "activeView" : ""}
                        />
                      </IconButton>
                    </Grid>
                    {location.search.includes("stagedOrder=1") ? (
                      stagedStoreLoaded &&
                      !stagedStore.filter((item) => !item.deleted).length ? (
                        <Grid item xs={12} textAlign="center">
                          <ShoppingCartIcon />
                          <Typography variant="h6">
                            Empty Staged Order
                          </Typography>
                        </Grid>
                      ) : customerStore &&
                        stagedStoreMapped &&
                        stagedStore.length > 0 &&
                        view === 1 ? (
                        stagedStore.map((item, index) =>
                          item.deleted ? (
                            <></>
                          ) : (
                            <Grid item xs={12} key={index}>
                              <CardCart
                                {...props}
                                data={item}
                                stagedChange={stagedChange}
                              />
                            </Grid>
                          ),
                        )
                      ) : (
                        <InfiniteTable
                          {...props}
                          columns={columns}
                          data={stagedStore}
                          dataMapByColumn="id"
                          deletable={false}
                          editable={true}
                          filterable={true}
                          label="Order Items"
                          fetchingModal={null}
                          storeAddons={true}
                        />
                      )
                    ) : customerStore &&
                      cartStore[customerStore.id].products.length > 0 &&
                      view === 1 ? (
                      cartStore[customerStore.id].products.map(
                        (item, index) => (
                          <Grid item xs={12} key={index}>
                            <CardCart {...props} data={item} />
                          </Grid>
                        ),
                      )
                    ) : cartStore[customerStore.id].products.length > 0 &&
                      view === 2 ? (
                      <InfiniteTable
                        {...props}
                        columns={columns}
                        data={cartStore[customerStore.id].products || []}
                        dataMapByColumn="id"
                        deletable={false}
                        editable={true}
                        filterable={true}
                        label="Order Items"
                        fetchingModal={null}
                        storeAddons={true}
                      />
                    ) : (
                      <Grid item xs={12} textAlign="center">
                        <ShoppingCartIcon />
                        <Typography variant="h6">Empty Cart</Typography>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={5}>
                  <FormCart
                    {...props}
                    handleNext={handleNext}
                    handleBackToAdd={handleBackToAdd}
                    handleCancel={handleCancel}
                    stagedStore={stagedStore}
                    stagedStoreLoaded={stagedStoreLoaded}
                    toggleSaveStagedOrderModal={toggleSaveStagedOrderModal}
                    total={
                      location.search.includes("stagedOrder=1")
                        ? stagedStoreTotal
                        : (customerStore &&
                            cartStore[customerStore.id].total) ||
                          0
                    }
                    ordersWithinDeadline={ordersWithinDeadline}
                    handleClickPlaceOrder={handleClickPlaceOrder}
                  />
                  <div
                    style={{ marginTop: theme.spacing(2), textAlign: "right" }}
                  >
                    <Button
                      color="success"
                      variant="contained"
                      disabled={
                        (location.search.includes("stagedOrder=1")
                          ? !stagedStore.length
                          : !cartStore[customerStore.id].products.length) ||
                        isSaving
                      }
                      onClick={handleClickPlaceOrder}
                      size="large"
                      sx={{
                        animation: `${pulseInset} 2s infinite ease-in-out`,
                      }}
                      className="place-order-button"
                    >
                      Place Order
                    </Button>
                  </div>
                </Grid>
              </>
            ) : activeStep === 1 ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <DetailsOrder
                    {...props}
                    columns={columns}
                    customer={customerStore}
                    data={
                      location.search.includes("stagedOrder=1")
                        ? stagedStore
                        : cartStore[customerStore.id].products
                    }
                    storeAddons={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: theme.spacing(1) }}
                      color="error"
                      variant="contained"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginLeft: theme.spacing(1) }}
                      color="inherit"
                      variant="contained"
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    <Button
                      style={{ marginLeft: theme.spacing(1) }}
                      color="success"
                      variant="contained"
                      disabled={
                        (location.search.includes("stagedOrder=1")
                          ? !stagedStore.length
                          : !cartStore[customerStore.id].products.length) ||
                        isSaving
                      }
                      onClick={handleClickPlaceOrder}
                      className="place-order-button"
                    >
                      Place Order
                    </Button>
                  </div>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default Items;
